import { GET_USAGE_DETAILS, SET_USAGE_DETAILS } from "./actionTypes"


export const getUsageDetails = (payload) => {
  return {
    type: GET_USAGE_DETAILS,
    payload: payload,
  }
}

export const setUsageDetails = (payload) => {
  return {
    type: SET_USAGE_DETAILS,
    payload: payload,
  }
}
